// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3-Cbh","info":"Note_info__1klnK","note":"Note_note__1TFrz","actions":"Note_actions__3p7fJ"};